import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Allleadership from "./Allleadership";

const InnovativeLeadership = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <section className="w-full py-4 sm:py-6 lg:py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-center tracking-wide dmsans"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            "Innovative Leadership"
          </h1>

          <p
            className="mt-4 sm:mt-6 lg:mt-8 text-sm sm:text-base md:text-lg lg:text-xl text-[#55586F] text-center leading-relaxed tracking-wide heebo max-w-7xl mx-auto"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            Sailesh Dani has consistently pioneered advancements in diverse
            sectors, including medical education, rehabilitation, and heavy
            engineering. His work embodies a commitment to integrating
            technology and innovation to create impactful solutions.
          </p>
        </div>

        <div className="mt-8 sm:mt-12 lg:mt-16">
          <Allleadership />
        </div>
      </div>
    </section>
  );
};

export default InnovativeLeadership;
